!( () => {
	const mql = window.matchMedia( "(min-width: 50.75rem)" );
	mql.matches && sidebarSetup();
	mql.addEventListener( "change", handleMediaChange, { once: false } )

	function sidebarSetup() {
		const sidebar = document.getElementById( 'chapter-sidebar' );
		if ( sidebar ) {
			const titleWrap = document.getElementById( 'chapter-title-wrap' );
			const style = window.getComputedStyle( sidebar, null );
			const padding = Number( style.getPropertyValue( "padding" ).replace( 'px', '' ) );

			titleWrap.style.position = "fixed";

			setTitleWidth( sidebar, padding )

			window.addEventListener( 'resize', throttle( setTitleWidth, 250, sidebar, padding ) );
		}
	}

	function setTitleWidth( sidebar, padding ) {
		let sidebarWidth = sidebar.offsetWidth - ( padding * 2 );
		const titleWrap = document.getElementById( 'chapter-title-wrap' );
		titleWrap.style.width = `${sidebarWidth}px`;
	}

	function destroySetup() {
		const titleWrap = document.getElementById( 'chapter-title-wrap' );
		if ( titleWrap )
			titleWrap.removeAttribute( 'style' );
	}


	function handleMediaChange( queryList ) {
		queryList.matches && sidebarSetup();
		!queryList.matches && destroySetup();
	}
} )();